import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    'filterForm',
    'tabbedContainer',
    'searchInput',
    'disconnectedSearchInput', // An "extra" search input that can appear anywhere on the page (inside this controllers scope), but doesn't have to be part of the form
    'disconnectedOtherInput', // Other disconnected inputs, such as "show_deleted" on accounting_entries page
    'resetSearch' // Added by shared/search_results partial anywhere it's used
  ];

  sanitizeAndValidateDateInputs() {
    var dateInputs, isValid;
    dateInputs = this.filterFormTarget.getElements('input[data-type=date]');
    var isValid = dateInputs.every(function(dateInput) {
      var date;
      date = new Date().parse(dateInput.value);
      // JS does a funny thing, if parsing 2023-11-31, it will actually return a date for 2023-12-01
      // This is obviously a valid date, so the check here passes, but now 2023-11-31 would be passed to the server
      // and ruby doesn't think 2023-11-31 is a valid date. So if js thinks we have a valid date, we also need to
      // update the value of the input so that we send a valid date to the server.
      var valid_check = Date.isValid(date) && date >= new Date().parse('2005-01-01');
      if(valid_check) { dateInput.value = date.format('%Y-%m-%d') }
      return valid_check;
    });

    return isValid;
  }

  // We submit the filter with a custom request instead of just clicking a hidden submit, to be able
  // to set/remove loading classes.
  submitFilter(event) {
    if(!this.hasTabbedContainerTarget || !this.hasFilterFormTarget) { return; }
    if(!this.sanitizeAndValidateDateInputs()) { return; }

    if(this.hasDisconnectedSearchInputTarget && this.searchInputTarget) {
      this.searchInputTarget.value = this.disconnectedSearchInputTarget.value
      if(event.target == this.disconnectedSearchInputTarget && this.disconnectedSearchInputTarget.value == '') { 
        // If the search input is empty, we return and instead click on the resetSearchTarget, because we
        // need to reset the session search.
        this.resetSearchTarget.click();
        return;
      }
    }

    if(this.hasDisconnectedOtherInputTarget) {
      this.disconnectedOtherInputTargets.forEach(inp => {
        var existing_input = this.filterFormTarget.elements[inp.name]
        // Checkboxes are special, since they either submit their value or nothing based on if they're
        // checked or not (which make them hard to 'reset'). This is normally handled by Rails (if using form.check_box, not check_box_tag) 
        // such that a form check box _also_ get's a hidden value above it that is set to 0, which is then
        // overriden by the check box input which has a value of 1. We have to mimic this logic here.
        var valueToSet = inp.value;
        if(inp.type == 'checkbox') { valueToSet = inp.checked ? '1' : '0' }
        if(existing_input) {
          // Since the input already exists, we just update it's value
          existing_input.value = valueToSet;
        } else {
          // The input doesn't already exist, so we create it and add it to the form
          var hiddenInput = document.createElement("input");
          hiddenInput.setAttribute("type", "hidden");
          hiddenInput.setAttribute("name", inp.name);
          hiddenInput.setAttribute("value", valueToSet);
          this.filterFormTarget.appendChild(hiddenInput);
        }
      });
    }

    new Form.Request(this.filterFormTarget, this.tabbedContainerTarget, {
      link: 'cancel',
      resetForm: false,
      requestOptions: {
        useSpinner: false,
        link: 'cancel',
        headers: { 'Accept': 'text/javascript, text/html, application/xml, text/xml, */*' },
        onRequest: function() {
            this.hasSearchInputTarget ? this.searchInputTarget.classList.add('loading') : null
            this.hasDisconnectedSearchInputTarget ? this.disconnectedSearchInputTarget.classList.add('loading') : null
            this.tabbedContainerTarget.classList.add('loading');
        }.bind(this),
        onComplete: function() {
            this.hasSearchInputTarget ? this.searchInputTarget.classList.remove('loading') : null
            this.hasDisconnectedSearchInputTarget ? this.disconnectedSearchInputTarget.classList.remove('loading') : null
            this.tabbedContainerTarget.classList.remove('loading');
            ExtendDOM.runAll(this.tabbedContainerTarget);
        }.bind(this)
      }
    }).send();
  }
}